import { render, staticRenderFns } from "./WishListProduct.vue?vue&type=template&id=2690efab&scoped=true"
import script from "./WishListProduct.vue?vue&type=script&lang=js"
export * from "./WishListProduct.vue?vue&type=script&lang=js"
import style0 from "./WishListProduct.vue?vue&type=style&index=0&id=2690efab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2690efab",
  null
  
)

export default component.exports